(ns common.specs.question
  (:require [clojure.spec.alpha :as s]

            [common.specs.universal]))

(s/def :question/uuid :common/uuid)
(s/def :question/body string?)

(s/def :question/type #{"single-answer"
                        "free-response"
                        "multiple-answer"})

(s/def ::question
  (s/keys :req-un [:question/uuid
                   :question/body]))
